// umlaut-check: skip — technische Bezeichner (verfuegbar) der Bestandskennzahlen.
// Gemeinsame Begriffe und Erklärtexte der einheitlichen Bestandsregel
// (Auftrag #315). Es gibt genau vier Begriffe — sie stehen überall im
// Ordermanagement gleich: Lagerbestand, reserviert, verfügbar und, grau,
// „offen, nicht reserviert“.

export const BEGRIFF = {
    lagerbestand: 'Lagerbestand',
    reserviert: 'reserviert',
    verfuegbar: 'verfügbar',
    offenNichtReserviert: 'offen, nicht reserviert',
};

/** Fester Erklärtext, der an jeder Bestandszahl im Tooltip steht. */
export const BESTAND_ERKLAERUNG = 'Aufträge reservieren Bestand: Sobald Ware für einen Auftrag oder Lieferschein '
    + 'per Entnahme zurückgelegt ist, gilt sie als reserviert und steht anderen Aufträgen nicht mehr zur Verfügung. '
    + 'Verfügbar ist, was im Lager liegt, abzüglich der von anderen Aufträgen reservierten Menge.';

/** Definition der grauen Zahl — dieselbe Zeile an jeder Stelle. */
export const OFFEN_NICHT_RESERVIERT_ERKLAERUNG = 'Offen, nicht reserviert: noch nicht gelieferte Menge offener Aufträge '
    + '(Status „in Erfassung“ oder „Auftragsbestätigung gedruckt“) abzüglich der schon reservierten Menge. '
    + 'Sie wird NICHT vom verfügbaren Bestand abgezogen, sondern nur zur Information gezeigt.';

/** Hinweis für die Planungssicht in Cosmos (Prognose, Lieferfähigkeit, Artikelblatt). */
export const COSMOS_PLANUNG_HINWEIS = 'Planungssicht: Cosmos zieht die gesamte offene Menge der Aufträge vom '
    + 'Lagerbestand ab, auch den schon reservierten Teil. Das ist vorsichtiger als „verfügbar“ im Auftrags-Editor und '
    + 'in der Bestandsübersicht, die nur die von anderen Aufträgen reservierte Menge abziehen.';

const zahlenFormat = new Intl.NumberFormat('de-DE', {maximumFractionDigits: 3});

/** Menge im deutschen Format; leere Werte als Gedankenstrich. */
export function menge(wert) {
    if (wert === null || wert === undefined || wert === '' || Number.isNaN(Number(wert))) {
        return '–';
    }
    return zahlenFormat.format(Number(wert));
}
